export interface ServiceLogger {
  debug: (...data: unknown[]) => void;
  error: (...data: unknown[]) => void;
  info: (...data: unknown[]) => void;
  warn: (...data: unknown[]) => void;
}

// Instrumentation and SSR routes can bundle separate copies of this module. Keep
// only the host logger in the runtime registry; request IDs and user data must be
// resolved by that logger at call time, never stored here.
const LOGGER_KEY = Symbol.for('@skin-seoul/service/logger');
const registry = globalThis as typeof globalThis & { [LOGGER_KEY]?: ServiceLogger };

/** Host apps inject their own logger (e.g. webapp SSR logger with request id prefix). */
export const setServiceLogger = (logger: ServiceLogger): void => {
  registry[LOGGER_KEY] = logger;
};

export const resetServiceLogger = (): void => {
  delete registry[LOGGER_KEY];
};

export const getServiceLogger = (): ServiceLogger => registry[LOGGER_KEY] ?? console;
